/* Offre quantité de la fiche cocooning — réplique du bloc Kaching d'Avenzo.
   La mécanique (lignes multiples, ajout au panier, tiroir) vient du kit ;
   seul l'affichage a été refait pour coller à la page d'origine. */
(function () {
  var LOT = document.querySelector('[data-cz-lot]');
  if (!LOT) return;

  var donnees = { options: [], variantes: [], pastilles: {} };
  try { donnees = JSON.parse(LOT.querySelector('[data-cz-donnees]').textContent); } catch (e) {}
  var variantes = donnees.variantes || [];
  var options   = donnees.options || [];
  var pastilles = donnees.pastilles || {};
  var devise = LOT.getAttribute('data-devise') || '€';
  var apres  = LOT.getAttribute('data-devise-apres') === '1';
  var vignette = LOT.getAttribute('data-vignette') || '';
  var base   = parseInt(LOT.getAttribute('data-prix'), 10) || 0;
  var plein1 = parseInt(LOT.getAttribute('data-prix-barre'), 10) || base;
  var alerte = LOT.querySelector('.cz-lot__epuise');
  var bilan  = LOT.querySelector('.cz-lot__bilan');
  var bilanV = LOT.querySelector('[data-cz-bilan]');

  /* Devise du client : en euro rien ne change ; dans une autre devise (francs suisses…),
     format de la devise et remises converties au taux de Shopify, comme au paiement. */
  var deviseClient = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var taux = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  function sous(c) {
    if (deviseClient !== 'EUR') {
      try { return new Intl.NumberFormat('fr-CH', { style: 'currency', currency: deviseClient }).format(c / 100); } catch (e) {}
    }
    var v = (c / 100).toFixed(2).replace('.', ',');
    return apres ? v + ' ' + devise : devise + v;
  }
  function coche() { return LOT.querySelector('input[name="cz-lot"]:checked'); }
  function quantite() { var c = coche(); return c ? parseInt(c.value, 10) : 1; }

  /* ── une ligne par article, dans chaque palier ─────────────────────────── */
  function dessiner() {
    [].forEach.call(LOT.querySelectorAll('.cz-lot__choix'), function (c) {
      var hote = c.querySelector('[data-cz-articles]');
      if (!hote || hote.childElementCount) return;          // déjà dessiné
      var n = parseInt(c.querySelector('input').value, 10);
      var offerts = parseInt(c.getAttribute('data-offerts'), 10) || 0;
      if (!options.length) return;
      /* relevé Venaro 19/09 : une ligne « Couleur, taille » 12/400 gris, puis « #1 [Couleur] [Taille] »
         (numéro 12/400, menus 34 px de haut, rayon 3.5) — pas de vignette, pas d'étiquette par menu */
      var proprietes = donnees.proprietes || [];
      var noms = options.concat(proprietes).map(function (o, k) { return k ? o.nom.toLowerCase() : o.nom; }).join(', ');
      var entete = document.createElement('span');
      entete.className = 'cz-lot__noms'; entete.textContent = noms; hote.appendChild(entete);
      for (var i = 0; i < n; i++) {
        var ligne = document.createElement('span');
        ligne.className = 'cz-lot__article';
        var html = '<span class="cz-lot__num">#' + (i + 1) + '</span><span class="cz-lot__menus">';
        for (var o = 0; o < options.length; o++) {
          html += '<select data-option="' + o + '" aria-label="' + options[o].nom + '">';
          for (var v = 0; v < options[o].valeurs.length; v++) {
            var val = options[o].valeurs[v];
            html += '<option value="' + val.replace(/"/g, '&quot;') + '">' + val + '</option>';
          }
          html += '</select>';
        }
        for (var q = 0; q < proprietes.length; q++) {
          html += '<select data-propriete="' + proprietes[q].nom + '" aria-label="' + proprietes[q].nom + '">';
          for (var w = 0; w < proprietes[q].valeurs.length; w++) {
            var val2 = proprietes[q].valeurs[w];
            html += '<option value="' + val2.replace(/"/g, '&quot;') + '">' + val2 + '</option>';
          }
          html += '</select>';
        }
        html += '</span>';
        ligne.innerHTML = html;
        hote.appendChild(ligne);
      }
    });
  }

  function trouver(choix) {
    for (var i = 0; i < variantes.length; i++) {
      var ok = true;
      for (var o = 0; o < choix.length; o++) if (variantes[i].options[o] !== choix[o]) { ok = false; break; }
      if (ok) return variantes[i];
    }
    return null;
  }

  function lignes(formule) {
    var c = coche(); if (!c) return [];
    var n = parseInt(c.value, 10);
    var hote = c.closest('.cz-lot__choix').querySelector('[data-cz-articles]');
    if (!options.length || !hote || !hote.querySelector('.cz-lot__article')) {
      var champ = formule && formule.querySelector('[name="id"]');
      var id = champ ? champ.value : (variantes[0] && variantes[0].id);
      return id ? [{ id: Number(id), quantity: n }] : [];
    }
    var sortie = [], manquant = false;
    [].forEach.call(hote.querySelectorAll('.cz-lot__article'), function (l) {
      /* les menus de variante (couleur) choisissent l'article ; ceux marqués data-propriete
         (la taille) ne sont qu'une note sur la ligne de commande : le produit est en taille unique */
      var choix = [].map.call(l.querySelectorAll('select:not([data-propriete])'), function (s) { return s.value; });
      var notes = {};
      [].forEach.call(l.querySelectorAll('select[data-propriete]'), function (s) { notes[s.getAttribute('data-propriete')] = s.value; });
      var v = trouver(choix);
      if (!v || !v.dispo) { manquant = true; return; }
      var ligne = { id: v.id, quantity: 1 };
      for (var k in notes) { ligne.properties = notes; break; }
      sortie.push(ligne);
    });
    if (alerte) alerte.hidden = !manquant;
    return manquant ? [] : sortie;
  }

  function majPrix() {
    [].forEach.call(LOT.querySelectorAll('.cz-lot__choix'), function (c) {
      var n = parseInt(c.querySelector('input').value, 10);
      /* remise en centimes, la même que la remise automatique Shopify du palier :
         le prix affiché tombe pile sur le total du panier (3 = 71,99 · 4 = 86,99) */
      var r = Math.round((parseInt(c.getAttribute('data-remise'), 10) || 0) * (deviseClient === 'EUR' ? 1 : taux));
      var net = base * n - r;
      /* ensemble seul (pas de remise) : barré au prix « comparé à » (49,99) ; lot (remise) : barré au vrai prix (39,99 × n),
         pour que « Économisez » = ce que le lot fait vraiment gagner (2+1 : 39,99 · 4 : 59,97). */
      var barre = (r > 0 ? base : plein1) * n;
      var p = c.querySelector('.cz-lot__prix');  if (p) p.textContent = sous(net);
      var b = c.querySelector('.cz-lot__barre'); if (b) b.textContent = barre > net ? sous(barre) : '';
      var e = c.querySelector('.cz-lot__badge');
      if (e) { var eco = barre - net; if (eco > 0) { e.textContent = (LOT.getAttribute('data-mot-eco') || 'Économisez') + ' ' + sous(eco);   /* « ÉCONOMISEZ 35,88 € » chez eux, relevé le 23/09/2026 : le mot en entier */ e.hidden = false; } else e.hidden = true; }
      c.setAttribute('data-eco', barre - net);
    });
    majBilan();
  }

  function majBilan() {}

  LOT.addEventListener('change', function (e) {
    if (e.target.name === 'cz-lot') { if (alerte) alerte.hidden = true; majBilan(); }
  });

  /* On prend la main sur le CLIC du bouton, pas sur le submit : le tiroir panier
     écoute déjà 'submit' sur document en capture et coupe la propagation. */
  document.addEventListener('click', function (e) {
    var bouton = e.target && e.target.closest && e.target.closest('[type="submit"]');
    if (!bouton) return;
    var formule = bouton.closest('form[action*="/cart/add"]');
    if (!formule) return;
    e.preventDefault(); e.stopPropagation();
    var items = lignes(formule);
    if (!items.length) return;
    bouton.setAttribute('aria-busy', 'true');
    var t = window.hyTiroirPanier;      /* la globale du tiroir ne change JAMAIS de nom */
    /* Le tiroir s'ouvre dès le clic, en « ajout en cours », et se remplit à la réponse de Shopify (05/10/2026). */
    var tout_de_suite = !!(t && t.ouvrirEnAjout);
    if (tout_de_suite) t.ouvrirEnAjout();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      if (t) return tout_de_suite ? t.rafraichir() : t.rafraichir().then(t.ouvrir);
      window.location.href = '/cart';
    }).catch(function () { if (t) return t.rafraichir(); }).then(function () {
      if (t && t.finAjout) t.finAjout();
      bouton.removeAttribute('aria-busy');
    });
  }, true);

  dessiner();
  majPrix();

  /* Prêt : un toucher fait avant ce moment (mis de côté par cz-bundle.liquid) est rejoué ici (05/10/2026). */
  window.czLotPret = true;
  var enAttente = window.czLotEnAttente; window.czLotEnAttente = null;
  if (enAttente) enAttente.click();
})();
